import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { countryCode } from "shared/types/countryCode";

export const getParametersForNorwegianTrainInSweden = (
  trainRoute: TrainRoute | undefined,
) => {
  const isNorwegianTrainInSweden =
    trainRoute?.trainIdentifier.countryCode === countryCode.Enum.SE &&
    trainRoute?.stops.some((stop) => stop.stopId === "Kogr");
  const norwegianTrainStaffCountryCode = isNorwegianTrainInSweden
    ? countryCode.Enum.NO
    : undefined;
  const norwegianTrainId = isNorwegianTrainInSweden
    ? trainRoute?.advertisedTrainNumber?.identifier
    : undefined;

  return {
    isNorwegianTrainInSweden,
    norwegianTrainStaffCountryCode,
    norwegianTrainId,
  };
};
